var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-container"},[_c('div',{staticClass:"container-header"},[_c('Header')],1),_c('div',{staticClass:"container-con"},[_c('router-view')],1),_c('div',{staticClass:"container-footer"},[_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }